import { render, staticRenderFns } from "./LedgerDetailFranchisee.vue?vue&type=template&id=e360c5c6"
import script from "./LedgerDetailFranchisee.vue?vue&type=script&lang=js"
export * from "./LedgerDetailFranchisee.vue?vue&type=script&lang=js"
import style0 from "./LedgerDetailFranchisee.vue?vue&type=style&index=0&id=e360c5c6&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports